import React from 'react'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'

export const Content = styled(ContainerBase)`
  &.MuiContainer-root {
    width: 100%;
  }
`

export const GridContainer = styled(({ margin, minHeight, padding, ...props }) => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    min-height: ${props => props.minHeight};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ margin, padding, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`
